var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXWhiteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 32,
    stroke: "#697077",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9709 21H46.2487L36.903 31.6815L47.8974 46.2167H39.2888L32.5463 37.4012L24.8313 46.2167H20.5509L30.547 34.7916L20 21H28.8271L34.9218 29.0577L41.9709 21ZM40.4695 43.6562H42.8399L27.5391 23.426H24.9955L40.4695 43.6562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhiteGray);
export default __webpack_public_path__ + "static/media/XWhiteGray.c514f6fb6ffd763830bf923952038c61.svg";
export { ForwardRef as ReactComponent };